import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            <p>&copy; {currentYear} Die Freiheitsmacher. Alle Rechte vorbehalten.</p>
          </div>
          
          <div className="footer-social" data-testid="social-links">
            <a 
              href="https://t.me/+iO7vHpUF-P03Y2Vi" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Telegram"
              data-testid="social-telegram"
            >
              <FontAwesomeIcon icon={faTelegram} />
            </a>
            <a 
              href="https://www.facebook.com/Anke2208/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
              data-testid="social-facebook"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a 
              href="https://www.instagram.com/anke_dittrich/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
              data-testid="social-instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a 
              href="https://www.tiktok.com/@ankedittrich" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="TikTok"
              data-testid="social-tiktok"
            >
              <FontAwesomeIcon icon={faTiktok} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
